// Registro estándar del service worker (patrón oficial de CRA). Solo corre
// en producción y por HTTPS (o localhost) — los requisitos de Chrome/Android
// para permitir instalar la app.
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  if (!isLocalhost && window.location.protocol !== 'https:') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.error('Error al registrar el service worker:', err));
  });
}
